import { z } from 'zod'

export enum CustomFieldType {
  Number = 'number',
  Text = 'string',
  Select = 'select',
}

export type CreateCustomFieldRequest = {
  name: string
  type: CustomFieldType
  options?: string[]
}

export type UpdateCustomFieldRequest = {
  name: string
  type: CustomFieldType
  options?: Array<{ id: string; value: string }>
}

export const customFieldStringSchema = z.object({
  id: z.string(),
  name: z.string().min(1, { message: 'Name is required' }),
  type: z.literal(CustomFieldType.Text, { required_error: 'Type is required' }),
})

export const customFieldNumberSchema = z.object({
  id: z.string(),
  name: z.string().min(1, { message: 'Name is required' }),
  type: z.literal(CustomFieldType.Number, { required_error: 'Type is required' }),
})

export const customFieldSelectSchema = z.object({
  id: z.string(),
  name: z.string().min(1, { message: 'Name is required' }),
  type: z.literal(CustomFieldType.Select, { required_error: 'Type is required' }),
  options: z.array(
    z.object({
      id: z.string(),
      value: z.string().min(1, { message: 'Option is required' }),
    })
  ),
})

export const customFieldSchema = z.union([
  customFieldStringSchema,
  customFieldNumberSchema,
  customFieldSelectSchema,
])

export type CustomField = z.infer<typeof customFieldSchema>

export type CustomFieldEditRequest = {
  id: string
  name: string
  type: CustomFieldType
  options?: Array<{ id: string | null; value: string }>
}

export const getCustomFieldsResponseSchema = z.object({
  custom_fields: z.array(customFieldSchema),
})

export const postCustomFieldResponseSchema = z.object({
  custom_field: customFieldSchema,
})

export const putCustomFieldResponseSchema = z.object({
  custom_field: customFieldSchema,
})

export const deleteCustomFieldResponseSchema = z.object({
  custom_field: customFieldSchema,
})
